<template>
  <div
    class="ly--outer--container"
    :class="bgWhite ? 'bg__white' : 'bg__crossSelling'"
  >
    <div class="cross-selling relative">
      <div class="swiper-nav prev">
        <ImageWrapper src="/assets/images/arrow.png" alt="" />
      </div>
      <div class="cross-selling__container ly--content--container">
        <div class="cross-selling__left--col">
          <div class="cross-selling-header">
            <h2 class="cross-selling-title col__black fz-40 fw-bold">
              {{ $t("crossSelling.title") }}
            </h2>
            <p
              class="cross-selling-subtitle col__black fz-16"
              v-html="$t('crossSelling.subtitle')"
            ></p>
          </div>
        </div>

        <!-- Carousel for remaining products -->
        <div class="cross-selling__right--col">
          <div class="carousel-wrapper">
            <swiper
              ref="mySwiper"
              :options="swiperOptions"
              class="products-carousel"
            >
              <swiper-slide
                v-for="(product, index) in carouselProducts"
                :key="index + 1"
                class="carousel-slide"
              >
                <div class="product__card">
                  <div class="product__content">
                    <div class="product__image--wrapper">
                      <ImageWrapper
                        :src="product.img"
                        :alt="product.name"
                        class="product__image"
                      />
                    </div>

                    <div class="product__info fz-20 text-center">
                      <h3 class="product__name">{{ product.name }}</h3>
                      <p class="product__price fw-bold">
                        HKD{{ product.price }}
                      </p>
                    </div>

                    <div class="sku-wrapper">
                      <AddToCart :id="product.sku" />
                    </div>

                    <!-- <div
                      class="product__addon"
                      :class="{ show: product.addon }"
                    >
                      {{
                        product.addon
                          ? product.addon
                          : "DUY THIS TO ENJOY FESTIVE OFFER TIER 2"
                      }}
                    </div> -->
                  </div>
                </div>
              </swiper-slide>
            </swiper>

            <!-- Navigation buttons -->
            <!-- <div class="swiper-button-prev custom-prev"></div>
            <div class="swiper-button-next custom-next"></div> -->
          </div>
        </div>
      </div>
      <div class="swiper-nav next">
        <ImageWrapper src="/assets/images/arrow.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Icons, AddToCart, ImageWrapper } from "~/components/";
import "swiper/css/swiper.css";

export default {
  name: "CrossSelling",
  props: {
    carouselProducts: {
      type: Array,
      default: () => [],
    },
    bgWhite: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    Icons,
    AddToCart,
    ImageWrapper,
  },
  data() {
    return {
      hoveredProduct: null,
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 24,
        // centeredSlides: true,
        navigation: {
          nextEl: ".swiper-nav.next",
          prevEl: ".swiper-nav.prev",
        },
        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 12,
            slidesOffsetBefore: 12,
            slidesOffsetAfter: 12,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 12,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
          1100: {
            slidesPerView: "auto",
            spaceBetween: 24,
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 24,
          },
        },
      },
    };
  },
  // computed: {
  //   /**
  //    * Returns the products for the carousel (excluding the first product)
  //    * @returns {Array} Array of product objects for carousel display
  //    */
  //   carouselProducts() {
  //     const products = this.$t("crossSelling.products");
  //     return products; // Remove first product as it's displayed separately
  //   },
  // },
  methods: {
    /**
     * Handles hover state for product cards
     * @param {number} index - Product index
     * @param {boolean} isHovered - Whether the product is being hovered
     */
    handleHover(index, isHovered) {
      this.hoveredProduct = isHovered ? index : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~/scss/include/_commonInclude.scss";

.cross-selling {
  padding-top: rem(124);
  padding-bottom: rem(95);

  // display: flex;
  // align-items: center;
  // gap: rem(24);

  .swiper-nav {
    width: rem(52);
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--Color, #bf936c);
    border-radius: 100%;
    cursor: pointer;

    position: absolute;
    top: 50%;

    &.prev {
      left: 0;
      transform: translateY(-50%);
    }

    &.next {
      right: 0;
      transform: translateY(-50%);
    }

    img {
      width: rem(12);
      height: auto;
    }

    &.next {
      img {
        transform: rotate(180deg);
      }
    }
  }

  .swiper-wrapper {
    // justify-content: center;
  }

  .product {
    &__image {
      // width: rem(97);
      width: 9.0625rem;
      height: auto;
      position: relative;
      z-index: 1;

      &--wrapper {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        aspect-ratio: 1;
        transition: transform 0.3s ease-in-out;

        &::before {
          content: "";
          display: block;
          width: 100%;
          position: absolute;
          border-radius: 100%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 1;
          width: calc(100% - rem(18));
          aspect-ratio: 1;
          background-color: color(white);
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
        }
      }
    }
    &__info {
      line-height: 1.2;
      display: flex;
      flex-direction: column;
      gap: rem(8);

      @include media-breakpoint-down(xl) {
        font-size: rem(16);
      }
    }
    &__content {
      display: flex;
      flex-direction: column;
      gap: rem(20);
      height: 100%;

      .sku-wrapper {
        flex: 1;
        display: flex;
        align-items: flex-end;
      }
    }
    &__card {
      color: color(black);
      height: 100%;

      &:hover {
        .product__image--wrapper::before {
          opacity: 0.4;
        }

        .product__image--wrapper {
          transform: translateY(-2%);
        }
      }
    }

    /**
     * Styling for product addon badge based on Figma design
     * Uses cherry magenta background with rounded corners
     */
    &__addon {
      background-color: color(cherryMagenta);
      color: color(white);
      padding: rem(8) rem(12);
      border-radius: rem(15);
      border-top-left-radius: 0;
      border-bottom-right-radius: 0;
      font-size: rem(12);
      text-align: center;
      display: block;
      line-height: 1.2;
      visibility: hidden;

      &.show {
        visibility: visible;
      }
    }
  }

  &-title {
    letter-spacing: 4px;
    text-transform: uppercase;
    margin-bottom: rem(16);
  }

  &-header {
    max-width: rem(249);
    text-align: left;
    @include media-breakpoint-down(xl) {
      max-width: unset;
      text-align: center;
    }
  }

  &__container {
    display: flex;
    gap: rem(20);
    justify-content: space-between;

    @include media-breakpoint-down(xl) {
      flex-direction: column;
    }
  }

  &__left--col {
  }
  &__right--col {
    flex: 0;
    // width: rem(800);
    width: 55rem;
    padding: 0 24px;
    @include media-breakpoint-down(xl) {
      width: 100%;
      padding: 0;
    }
    // .sku-wrapper > div {
    //   @include media-breakpoint-down(md) {
    //     width: 100%;
    //   }
    // }

    // .AddToBagButtonLarge__label {
    //   @include media-breakpoint-down(md) {
    //     font-size: rem(12);
    //   }
    // }
  }

  .carousel-wrapper {
    width: 100%;
    // padding-left: rem(24);
    overflow: hidden;

    @include media-breakpoint-down(md) {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    .AddToBagButton {
      max-width: 100%;
    }

    .swiper-container {
      overflow: visible;
    }

    @include media-breakpoint-down(xl) {
      padding: 0 rem(24);

      .swiper-container {
        overflow: hidden;
      }
    }
  }
}

/**
 * Carousel slide styling with responsive behavior
 * Fixed 180px width above 1100px, flexible width below 1100px for 4 slides per view
 */
.carousel-slide {
  height: unset !important;
  // background-color: red;
  @media (min-width: 1100px) {
    width: rem(180) !important;
    flex-shrink: 0;
  }

  // @media (max-width: 1099px) {
  //   width: auto !important;
  //   flex-shrink: 1;
  // }
}

// .cross-selling {
//   padding: rem(80) 0;
//   background-color: color(white);

//   .cross-selling-header {
//     margin-bottom: rem(60);

//     .cross-selling-title {
//       font-size: rem(48);
//       font-weight: 700;
//       margin-bottom: rem(20);

//       @include media-breakpoint-down(md) {
//         font-size: rem(36);
//       }
//     }

//     .cross-selling-subtitle {
//       font-size: rem(18);
//       max-width: rem(600);
//       margin: 0 auto;
//       line-height: 1.6;

//       @include media-breakpoint-down(md) {
//         font-size: rem(16);
//       }
//     }
//   }

//   .product-card {
//     background: color(white);
//     border-radius: rem(12);
//     overflow: hidden;
//     transition: all 0.3s ease;
//     height: 100%;
//     box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

//     &:hover {
//       transform: translateY(rem(-5));
//       box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
//     }

//     .product-image-wrapper {
//       position: relative;
//       overflow: hidden;
//       aspect-ratio: 1;

//       .product-image {
//         width: 100%;
//         height: 100%;
//         object-fit: cover;
//         transition: transform 0.3s ease;
//       }

//       .product-hover-overlay {
//         position: absolute;
//         top: 0;
//         left: 0;
//         right: 0;
//         bottom: 0;
//         background: rgba(255, 255, 255, 0.95);
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         opacity: 0;
//         visibility: hidden;
//         transition: all 0.3s ease;

//         &.active {
//           opacity: 1;
//           visibility: visible;
//         }

//         .add-to-cart-btn {
//           background: color(black);
//           color: color(white);
//           border: none;
//           padding: rem(12) rem(24);
//           font-size: rem(14);
//           font-weight: 600;
//           text-transform: uppercase;
//           letter-spacing: rem(1);
//           border-radius: rem(4);
//           cursor: pointer;
//           transition: all 0.3s ease;

//           &:hover {
//             background: color(gray-800);
//             transform: translateY(rem(-2));
//           }
//         }
//       }
//     }

//     .product-info {
//       padding: rem(20);

//       .product-name {
//         font-size: rem(20);
//         font-weight: 600;
//         color: color(black);
//         margin-bottom: rem(8);
//       }

//       .product-sku {
//         font-size: rem(14);
//         color: color(gray-500);
//         margin-bottom: rem(8);
//       }

//       .product-price {
//         font-size: rem(24);
//         font-weight: 700;
//         color: color(black);
//         margin-bottom: rem(12);
//       }

//       .product-addon {
//         font-size: rem(12);
//         color: color(primary);
//         font-weight: 600;
//         text-transform: uppercase;
//         letter-spacing: rem(0.5);
//         line-height: 1.4;
//       }
//     }
//   }

//   .carousel-wrapper {
//     position: relative;

//     .products-carousel {
//       padding: rem(10) 0;

//       .carousel-slide {
//         height: auto;
//       }
//     }

//     .custom-prev,
//     .custom-next {
//       position: absolute;
//       top: 50%;
//       transform: translateY(-50%);
//       width: rem(44);
//       height: rem(44);
//       background: color(white);
//       border: 2px solid color(gray-200);
//       border-radius: 50%;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       cursor: pointer;
//       z-index: 10;
//       transition: all 0.3s ease;

//       &:after {
//         font-size: rem(16);
//         font-weight: 700;
//         color: color(black);
//       }

//       &:hover {
//         background: color(black);
//         border-color: color(black);

//         &:after {
//           color: color(white);
//         }
//       }

//       &.swiper-button-disabled {
//         opacity: 0.3;
//         cursor: not-allowed;

//         &:hover {
//           background: color(white);
//           border-color: color(gray-200);

//           &:after {
//             color: color(black);
//           }
//         }
//       }
//     }

//     .custom-prev {
//       left: rem(-22);
//     }

//     .custom-next {
//       right: rem(-22);
//     }
//   }
// }

// @include media-breakpoint-down(lg) {
//   .cross-selling-section {
//     .carousel-wrapper {
//       .custom-prev {
//         left: rem(-15);
//       }

//       .custom-next {
//         right: rem(-15);
//       }
//     }
//   }
// }

// @include media-breakpoint-down(md) {
//   .cross-selling-section {
//     padding: rem(60) 0;

//     .cross-selling-header {
//       margin-bottom: rem(40);
//     }

//     .carousel-wrapper {
//       margin-top: rem(30);

//       .custom-prev,
//       .custom-next {
//         display: none;
//       }
//     }
//   }
// }
</style>
